module.exports = __webpack_public_path__ + "media/assets/fonts/Roboto-Light-8be2d1487420548b3b8ddba68270b26b.ttf";